import { createContext } from 'react';
import {
    QUERY_KEYS_IGD,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';

export const IgdChartsDataContext = createContext();

const IgdChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();
    const filterParams = {
        year: filters.year?.value || '',
        month: filters.month?.value || '',
        location: filters.unidade.value,
        city: filters.cidade?.value,
    };
    
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_IGD.GENERAL_RESULTS,
            url: 'governanceroom/socialdashboard/igd/igdmEvolution'
        },
        filterParams
    );

    const schoolCharts = useChartsData(
        {
            key: QUERY_KEYS_IGD.SCHOOL_ATTENDANCE,
            url: 'governanceroom/socialdashboard/igd/schoolAttendance'
        },
        filterParams
    );

    const healthScheduleCharts = useChartsData(
        {
            key: QUERY_KEYS_IGD.HEALTH_SCHEDULE,
            url: 'governanceroom/socialdashboard/igd/healthSchedule'
        },
        filterParams
    );

    const registrationUpdatesCharts = useChartsData(
        {
            key: QUERY_KEYS_IGD.REGISTRATION_UPDATES,
            url: 'governanceroom/socialdashboard/igd/registrationUpdate'
        },
        filterParams
    );

    const chartData = data
        ? {
              anualEvolution: data?.anualEvolution ?? [],
              monthEvolution: data?.monthEvolution ?? [],
              schoolAttendanceAnual: schoolCharts?.data?.anualEvolution ?? [],
              schoolAttendanceMonth: schoolCharts?.data?.monthEvolution ?? [],
              healthScheduleAnual: healthScheduleCharts?.data?.anualEvolution ?? [],
              healthScheduleMonth: healthScheduleCharts?.data?.monthEvolution ?? [],
              registrationUpdatesAnual: registrationUpdatesCharts?.data?.anualEvolution ?? [],
              registrationUpdatesMonth: registrationUpdatesCharts?.data?.monthEvolution ?? []
          }
        : {
              anualEvolution: [],
              monthEvolution: [],
              schoolAttendanceAnual: [],
              schoolAttendanceMonth: [],
              healthScheduleAnual: [],
              healthScheduleMonth: [],
              registrationUpdatesAnual: [],
              registrationUpdatesMonth: []
          };


    return (
        <IgdChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </IgdChartsDataContext.Provider>
    );
};

export default IgdChartsDataProvider;
